import { render, staticRenderFns } from "./MediabankCategoryList.vue?vue&type=template&id=e4e51ebe&"
import script from "./MediabankCategoryList.vue?vue&type=script&lang=js&"
export * from "./MediabankCategoryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports